import { DATAGRID_AVATAR_COLORS } from "Constants";

export const getDataGridRandomAvatarColor = (studentId = "") => {
  let sum = 0;
  const colorsLength = DATAGRID_AVATAR_COLORS.length;

  for (let i = 0; i < studentId.length; i++) {
    sum += studentId.charCodeAt(i) % 10;
  }

  return DATAGRID_AVATAR_COLORS[sum % colorsLength];
};
